import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AutoMlService } from 'src/app/core/service/auto-ml.service';

@Component({
  selector: 'app-flow-header',
  templateUrl: './flow-header.component.html',
  styleUrls: ['./flow-header.component.scss']
})
export class FlowHeaderComponent {
  isOpen=false;
  constructor(
    private auService:AutoMlService,
    private toast:ToastrService,
    public router:Router
  ){}

  logout(){
    this.auService.logoutEtl()
    .subscribe((res:any)=>{
      if(res.detail==='Successfully logged out.'){
        this.toast.success(res.detail);
        this.router.navigateByUrl('login').then(()=>{
          let d:Date = new Date();
          d.setTime(d.getTime() + -1 * 24 * 60 * 60 * 1000);
          let expires:string = `expires=${d.toUTCString()}`;
          document.cookie = `token='';${expires}`
          // location.reload();
        })
      }
    })
  }
}
